import { render, staticRenderFns } from "./communityActList.vue?vue&type=template&id=6ec136d5&scoped=true&"
import script from "./communityActList.vue?vue&type=script&lang=js&"
export * from "./communityActList.vue?vue&type=script&lang=js&"
import style0 from "./communityActList.vue?vue&type=style&index=0&id=6ec136d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec136d5",
  null
  
)

export default component.exports